import styled from 'styled-components';
import ArticleCardThumbnail from '@/atoms/ArticleCardThumbnail';
import ArticleCardInfo from '@/molecules/ArticleCardInfo';
import ArticleCardTagsList from '@/molecules/ArticleCardTagsList';
import { mediaQuery } from '@/styles/media';

const Wrapper = styled.div`
  background-color: #f6f6f6;
  border-bottom: 1px solid #eee;
  width: 100%;
  margin-top: 20px;
  padding: 20px;
`;

const Header = styled.h2`
  padding: 0 0 10px 10px;
  grid-area: header;
  font-weight: normal;
  font-size: 16px;
  ${mediaQuery.sp} {
    font-weight: bold;
    font-size: 20px;
  }
`;

const GridWrapper = styled.div`
  display: grid;
  gap: 20px;
  grid-template-columns: repeat(3, minmax(30%, 1fr));

  ${mediaQuery.tb} {
    grid-template-columns: repeat(2, minmax(40%, 1fr));
  }

  ${mediaQuery.sp} {
    grid-template-columns: 1fr;
  }
`;

const Card = styled.div`
  display: grid;
  grid-template-columns: repeat(1, minmax(30%, 1fr));
  grid-template-rows: auto auto 1fr auto;
  grid-template-areas:
   "thumbnail"
   "info"
   "."
   "tags"
  ; 
  padding: 20px;
  background: #fff;
  box-shadow: 0 0 5px rgba(0, 0, 0, 0.05);
  align-items: start;
  min-width: 0;
  max-width: 100%;

 
  ${mediaQuery.sp} {
    grid-template-columns: minmax(30%, 150px) 1fr;
    grid-template-rows: auto auto;
    grid-template-areas:
      "thumbnail info"
      "thumbnail tags";
    gap: 10px 20px;
  }
`;

const ThumbnailWrapper = styled.div`
  grid-area: thumbnail;
`;

const InfoWrapper = styled.div`
  grid-area: info;
`;

const TagsWrapper = styled.div`
  grid-area: tags;
`;

type Props = {
  posts: GatsbyTypes.MarkdownRemark[];
  siteTags: GatsbyTypes.SiteTag[];
};

const RelatedPostsList: React.FC<Props> = ({ posts, siteTags }) => {
  return (
    <Wrapper>
      <Header>関連記事</Header>
      <GridWrapper>
        {posts.map((post, i) => {
          const tagsMap: Map<string, string> = new Map();
          // biome-ignore lint/complexity/noForEach: Bimome初回導入のために、一時的に無視する
          siteTags.forEach((tag) =>
            tagsMap.set(tag.slug || '', tag.title || ''),
          );
          const imageUrl = (() => {
            if (post.frontmatter?.image_public_url)
              return post.frontmatter.image_public_url;
            if (post.frontmatter?.image?.publicURL)
              return post.frontmatter.image.publicURL;
            return undefined;
          })();

          return (
            <Card key={post.frontmatter?.title || i}>
              <ThumbnailWrapper>
                <ArticleCardThumbnail imageUrl={imageUrl} post={post} />
              </ThumbnailWrapper>
              <InfoWrapper>
                <ArticleCardInfo post={post} isRelatedArticle />
              </InfoWrapper>
              <TagsWrapper>
                <ArticleCardTagsList tagsMap={tagsMap} post={post} />
              </TagsWrapper>
            </Card>
          );
        })}
      </GridWrapper>
    </Wrapper>
  );
};

export default RelatedPostsList;
